import request from '../../../services/request';
export var getFulfillmentLocations = function getFulfillmentLocations(fulfillerId) {
  return request("https://startingpriceapi.financialflows.cimpress.io/v1/fulfillmentLocations/" + fulfillerId);
};
export var getFulfillmentLocationInfo = function getFulfillmentLocationInfo(fulfillmentLocationId) {
  return request("https://startingpriceapi.financialflows.cimpress.io/v1/fulfillmentLocationInfo/" + fulfillmentLocationId);
};